import { Input, InputNumber, Radio, Select, Switch } from 'antd';
import { useAppDispatch, useAppState } from '../../store/hooks';
import type { PrintSettings as Settings } from '../../api/types';
import styles from './styles.module.css';

const PAPER_OPTIONS: { value: Settings['paperSize']; label: string }[] = [
  { value: 'A4', label: 'A4' },
  { value: 'A5', label: 'A5' },
  { value: 'A3', label: 'A3' },
  { value: 'Letter', label: 'Letter' },
];

export function PrintSettings() {
  const { settings } = useAppState();
  const dispatch = useAppDispatch();

  const update = (patch: Partial<Settings>) =>
    dispatch({ type: 'UPDATE_SETTINGS', settings: patch });

  return (
    <div className={styles.panel}>
      <div className={styles.row}>
        <span className={styles.label}>标题</span>
        <Input
          size="small"
          className={styles.fill}
          placeholder="留空则不显示标题"
          value={settings.title}
          onChange={(e) => update({ title: e.target.value })}
          maxLength={80}
        />
      </div>

      <div className={styles.row}>
        <span className={styles.label}>纸张</span>
        <Select
          size="small"
          className={styles.fill}
          value={settings.paperSize}
          options={PAPER_OPTIONS}
          onChange={(v) => update({ paperSize: v })}
        />
      </div>

      <div className={styles.row}>
        <span className={styles.label}>方向</span>
        <Radio.Group
          size="small"
          value={settings.orientation}
          onChange={(e) => update({ orientation: e.target.value })}
        >
          <Radio.Button value="portrait">纵向</Radio.Button>
          <Radio.Button value="landscape">横向</Radio.Button>
        </Radio.Group>
      </div>

      <div className={styles.row}>
        <span className={styles.label}>边距</span>
        <InputNumber
          size="small"
          className={styles.fill}
          min={0}
          max={50}
          step={1}
          value={settings.marginMm}
          onChange={(v) => update({ marginMm: typeof v === 'number' ? v : 10 })}
          addonAfter="mm"
        />
      </div>

      <div className={styles.row}>
        <span className={styles.label}>字号</span>
        <InputNumber
          size="small"
          className={styles.fill}
          min={8}
          max={28}
          step={1}
          value={settings.fontSizePx}
          onChange={(v) => update({ fontSizePx: typeof v === 'number' ? v : 12 })}
          addonAfter="px"
        />
      </div>

      <div className={styles.row}>
        <span className={styles.label}>行号</span>
        <Switch
          size="small"
          checked={settings.showIndex}
          onChange={(v) => update({ showIndex: v })}
        />
      </div>
    </div>
  );
}
